import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { MethodPreference } from '@thiememeulenhoff/types';
import { PreferenceEndpointService } from './preference.endpoint.service';

@Service()
export class PreferenceService {
  readonly #http = inject(HttpClient);

  readonly #endpoints = inject(PreferenceEndpointService);

  fetchPreferences() {
    const endpoint = this.#endpoints.getPreferences();

    return this.#http.get<Array<MethodPreference>>(endpoint);
  }

  setMethodPreference(preference: MethodPreference) {
    const endpoint = this.#endpoints.setPreferenceForMethod(preference.method);

    return this.#http.post<MethodPreference>(endpoint, preference);
  }

  deleteMethodPreference(methodSlug: string) {
    const endpoint = this.#endpoints.deletePreferenceForMethod(methodSlug);

    return this.#http.delete(endpoint);
  }

  addArrangementToMethodPreference(
    methodSlug: string,
    arrangementCode: string,
  ) {
    const endpoint = this.#endpoints.arrangementPreferenceForMethod(
      methodSlug,
      arrangementCode,
    );

    return this.#http.post(endpoint, {});
  }

  deleteArrangementFromMethodPreference(
    methodSlug: string,
    arrangementCode: string,
  ) {
    const endpoint = this.#endpoints.arrangementPreferenceForMethod(
      methodSlug,
      arrangementCode,
    );

    return this.#http.delete(endpoint);
  }
}
